import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const EXPANDED_VIEW_ITEM_SUMMARY_SCHEMA = Object.freeze({
  TITLE: '',
  DEEPLINK: '',
  QUANTITY: 0,
  TOTAL_AMOUNT: 0,
  CONTEXT_LABEL: '',
  RANK: null, // optional
});
export const RECORD = generateSchema(EXPANDED_VIEW_ITEM_SUMMARY_SCHEMA);
export const KEYS: any = generateKeys(EXPANDED_VIEW_ITEM_SUMMARY_SCHEMA);

export class ExpandedViewItem extends Record(RECORD) {
  static KEYS: any = KEYS;

  static fromJsonList(array: any[]): List<ExpandedViewItem> {
    return List<ExpandedViewItem>(
      array ? array.map((props) => new ExpandedViewItem(props)) : []
    );
  }

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get deeplink(): string {
    return this.get(KEYS.DEEPLINK);
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }

  get quantity(): number {
    return this.get(KEYS.QUANTITY);
  }

  get totalAmount(): number {
    return this.get(KEYS.TOTAL_AMOUNT);
  }

  get contextLabel(): string {
    return this.get(KEYS.CONTEXT_LABEL);
  }

  get rank(): number {
    return this.get(KEYS.RANK);
  }
}
